import { Link } from 'react-router-dom';
import { MessageCircle, ArrowRight } from 'lucide-react';

export default function CTA() {
  return (
    <section className="py-20 bg-brand-dark text-brand-cream relative overflow-hidden">
      <div className="absolute -top-32 right-0 w-96 h-96 bg-brand-lime/15 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 left-0 w-96 h-96 bg-brand-green/30 rounded-full blur-3xl" />
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="heading-display text-3xl md:text-5xl text-brand-cream">Let’s Power the Next Move.</h2>
        <p className="mt-4 text-brand-cream/75 max-w-2xl mx-auto">
          Whether you're looking for mobility, bringing vehicles to the platform, or exploring a partnership — connect with E Drives.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact" className="btn-primary-pill">
            Talk to Us <ArrowRight size={18} />
          </Link>
          <Link to="/mobility-verticals" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-transparent border-2 border-brand-cream/40 text-brand-cream font-semibold hover:bg-brand-cream/10 hover:border-brand-lime hover:text-brand-lime transition-all">
            Explore E Drives <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
